import { ZCDColor } from '@zencity/common-ui';
import { ZCDIconProps } from '@zencity/common-ui/lib/ZCD/ZCDIcon/ZCDIcon';
import { ZCDTypographyProps } from '@zencity/common-ui/lib/ZCD/ZCDTypography/ZCDTypography';
import i18next from 'i18next';
import { NO_COMPARISON } from 'screens/WidgetGenerator/constants';

export const INFO_KEYS = [
  {
    color: ZCDColor.ZCD_GREEN_90,
    text: i18next.t('widgetGenerator.widgets.servicesBarChart.legend.infoKeys.positive'),
  },
  {
    color: ZCDColor.ZCD_GRAY_40,
    text: i18next.t('widgetGenerator.widgets.servicesBarChart.legend.infoKeys.neutral'),
  },
  {
    color: ZCDColor.ZCD_RED_30,
    text: i18next.t('widgetGenerator.widgets.servicesBarChart.legend.infoKeys.negative'),
  },
];

interface LegendDataBase {
  title: string;
}

interface LegendDataText extends LegendDataBase {
  textContent: { text: string; color: ZCDTypographyProps['color'] }[];
  iconContents?: never;
}

interface LegendDataIcon extends LegendDataBase {
  iconContents: { name: ZCDIconProps['name']; color: ZCDIconProps['color'] }[];
  textContent?: never;
}

export type LegendData = LegendDataText | LegendDataIcon;

export const LEGEND_DATA: LegendData[] = [
  {
    iconContents: [
      { name: 'arrow-down', color: 'zcd-green-90' },
      { name: 'arrow-up', color: 'zcd-green-90' },
    ],
    title: i18next.t('widgetGenerator.widgets.servicesBarChart.legend.changeKeys.changeInPositiveScore'),
  },
  {
    iconContents: [
      { name: 'arrow-down', color: 'zcd-red-30' },
      { name: 'arrow-up', color: 'zcd-red-30' },
    ],
    title: i18next.t('widgetGenerator.widgets.servicesBarChart.legend.changeKeys.changeInNegativeScore'),
  },
  {
    textContent: [{ text: NO_COMPARISON, color: 'zcd-red-30' }],
    title: i18next.t('widgetGenerator.widgets.servicesBarChart.legend.changeKeys.noData'),
  },
];

export const determineLegendData = (displayNoDataExplanation?: boolean): LegendData[] => {
  if (displayNoDataExplanation) {
    return LEGEND_DATA;
  }

  return LEGEND_DATA.filter(
    (legendElement) =>
      legendElement.title !== i18next.t('widgetGenerator.widgets.servicesBarChart.legend.changeKeys.noData'),
  );
};
